import { Trans, useTranslation } from 'react-i18next'
import useMediaPermissionActions from '../functionalities/mediaPermissions/useMediaPermissionActions'
import { Alert } from '@/UIComponents2/Alert'
import { Button } from '@/UIComponents2/Button'
import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { DialogBody, DialogTitle } from '@/components/Dialog'
import { useUserContext } from '@/UserContext'
import { env } from '@/services/EnvironmentVariables'

export default function RemoteDesktopControlPermissionDialogContent({
    requesterName,
    onAccept,
    onDeny,
}: {
    requesterName: string
    onAccept: () => void
    onDeny: () => void
}) {
    const { t } = useTranslation()
    const mac = env.OS === 'darwin'

    return (
        <div className="w-full">
            <DialogBody>
                <DialogTitle>Remote Control Confirmation</DialogTitle>

                <div>{t(`{{askerName}} wants to control your desktop.`, { askerName: requesterName })}</div>
                <div className="t-base-light pt-4">
                    <Trans
                        i18nKey="Press <0 /> at any time to revoke control."
                        t={t}
                        components={[
                            <span className="t-base-bold" key="0">
                                {mac ? 'Ctrl+Shift+G' : 'Alt+Shift+G'}
                            </span>,
                        ]}
                    />
                </div>

                <PermissionAlert />
            </DialogBody>

            <DialogActionButtonsSection
                leftButtonText={t('Deny')}
                onLeftButtonClicked={onDeny}
                rightButtonText={t('Allow')}
                onRightButtonClicked={onAccept}
            />
        </div>
    )
}

function PermissionAlert() {
    const [userState] = useUserContext()

    const { openPrivacyPreferencesSettings } = useMediaPermissionActions()

    if (!userState.mediaPermissions?.accessibility) {
        return (
            <Alert className="my-3" variant="solid" level="warning">
                <div className="flex flex-col">
                    <span>
                        <Button
                            variant="link"
                            onClick={(e) => {
                                e.preventDefault()
                                openPrivacyPreferencesSettings('accessibility')
                            }}
                        >
                            Accessibility permission
                        </Button>{' '}
                        has not been allowed for Muse. Screen control features may not work without this permission.
                    </span>
                </div>
            </Alert>
        )
    }

    return null
}
